<template lang="pug">
.course-constructor
  v-app-bar(
    v-if="!readonly"
    color="secondary"
    dark
    app
    flat
  )
    v-container
      v-row(no-gutters align="center")
        v-btn(
          color="secondary lighten-2"
          depressed
          @click="onExit"
        ).mr-4
          v-icon(left) mdi-chevron-left
          span Сохранить и выйти
        div.d-none.d-sm-block
          .caption.grey--text Документ
          span {{ title }}
        v-spacer
        .caption(v-if="loading.save") Идет сохранение...
  v-main.course-constructor__body
    v-slide-y-transition(group leave-absolute)
      CC-section(
        v-for="(section, idx) in constructorData"
        v-model="constructorData[idx]"
        :key="section.hash"
        :ref="`section-${section.hash}`"
        :id="`section-${idx}`"
        :first="idx === 0"
        :last="idx === constructorData.length - 1"
        :readonly="readonly"
        @move:after="moveSection(idx, idx + 1)"
        @move:before="moveSection(idx, idx - 1)"
        @remove="removeSection(idx)"
        @add:after="createSection(idx + 1)"
        @add:before="createSection(idx)"
      )
</template>
<script>
import { randomBytes } from 'crypto';
import CCSection from '@/modules/CourseManagement/components/Constructor/CCSection.vue';

export default {
  components: {
    CCSection,
  },
  data() {
    return {
      title: null,
      constructorData: [],
      loading: {
        save: false,
      },
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    readonly() {
      return this.$route.meta.readonly;
    },
  },
  created() {
    this.getConstructorData();
  },
  methods: {
    async getConstructorData() {
      const { data } = await this.$api.contracts.getAgreement(this.id);
      this.title = data.data.title;
      this.constructorData = data.data.data || [{ hash: randomBytes(20).toString('hex'), title: data.data.title, description: null }];
    },
    async onExit() {
      await this.save();
      this.$router.push({
        name: 'PaymentAgreements',
      });
    },
    async save() {
      this.loading.save = true;
      const payload = this.constructorData;
      await this.$api.contracts.saveAgreement(this.id, { data: payload });
      this.loading.save = false;
    },
    scrollToPosition(positionIdx) {
      this.$vuetify.goTo(`#section-${positionIdx}`);
    },
    moveSection(oldPosition, newPosition) {
      const movingElement = this.constructorData[oldPosition];
      this.constructorData.splice(oldPosition, 1);
      this.constructorData.splice(newPosition, 0, movingElement);
      this.scrollToPosition(newPosition);
    },
    removeSection(positionIdx) {
      this.constructorData.splice(positionIdx, 1);
    },
    createSection(positionIdx) {
      const { constructorData, scrollToPosition } = this;
      constructorData.splice(positionIdx, 0, { hash: randomBytes(20).toString('hex'), title: null, description: null });
      scrollToPosition(positionIdx);
    },
  },
};
</script>
